module.exports = __webpack_public_path__ + "img/H1.474b6cb2.png";